import React from "react";
import clients from "../../data/clients";

const ClientLogos = () => {
  const allClients = [...clients, ...clients]; // Duplicate for seamless loop

  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4 font-heading">
            Our Trusted Clients
          </h2>

          <div className="w-24 h-1 bg-black mx-auto mt-4 mb-6"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-800 mb-12">
            It's been our privilege to partner with clients from a wide array of
            industries.{" "}
          </p>
        </div>

        <div className="logo-marquee">
          <div className="logo-track">
            {allClients.map((client, index) => (
              <div className="logo-item" key={index}>
                <img
                  src={client.img}
                  alt={`${client.name} Logo`}
                  style={{
                    maxHeight: client.height || "60px",
                    maxWidth: client.maxWidth || "120px",
                    // filter: "grayscale(100%)",
                    // transition: "filter 0.3s",
                  }}
                  // onMouseEnter={(e) =>
                  //   (e.currentTarget.style.filter = "none")
                  // }
                  // onMouseLeave={(e) =>
                  //   (e.currentTarget.style.filter = "grayscale(100%)")
                  // }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
